


















































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import BriocheImageTag from 'frontend/components/BriocheImageTag.vue';
import ResponsiveImage from 'frontend/components/ResponsiveImage.vue';
import Reviews from 'frontend/views/premium/Reviews.vue';
import PaywallFeatures from 'frontend/views/premium/paywall/PaywallFeatures.vue';
import PremiumFeatures from 'frontend/views/premium/PremiumFeatures.vue';
import WhatCanILearn from 'frontend/views/premium/paywall/WhatCanILearn.vue';
import JoinCTA from 'frontend/views/landing/JoinCTA.vue';
import LandingFooter from 'frontend/views/landing/LandingFooter.vue';
import { MobileGetter } from 'frontend/types';

@Component({
  components: {
    BriocheImageTag,
    JoinCTA,
    LandingFooter,
    ResponsiveImage,
    Reviews,
    WhatCanILearn,
    PaywallFeatures,
    PremiumFeatures,
  },
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class PageContent extends Vue {
  private isMobile!: MobileGetter;
}
